"use client";

import { toast as sonnerToast } from "sonner";

function toast(message: string) {
  return sonnerToast(message);
}

export { toast };
